"use client";

// These files are the single source of truth for BOTH distribution channels
// of the Magnus floating shell: the `@bg-bgi/magnus-ui` npm package
// (packages/sdk/ui inlines them at build time, `./floating` subpath) and the
// shadcn registry (`magnus-floating` block — synced copies under
// packages/ui/registry/blocks/). The private `@magnus/react/floating` and
// `@magnus/react` host module re-export from here. Edit here; never fork.

export {
  FLOATING_CHAT_HEADER_CONTROL_SELECTOR,
  FloatingChat,
  FloatingChatBody,
  FloatingChatDefaultHeaderContent,
  FloatingChatHeader,
  type FloatingChatLauncherPosition,
  FloatingChatLayoutMenu,
  FloatingChatMinimizeButton,
  FloatingChatNewChatButton,
  FloatingChatPanel,
  FloatingChatTitle,
  FloatingChatTrigger,
  type FloatingChatTriggerBehavior,
} from "./floating-chat";
export {
  type FloatingChatActions,
  type FloatingChatContextValue,
  type FloatingChatHistorySource,
  type FloatingChatInsets,
  type FloatingChatMeta,
  type FloatingChatPresentation,
  FloatingChatRoot,
  type FloatingChatRootProps,
  type FloatingChatSide,
  type FloatingChatSources,
  FloatingChatSourcesProvider,
  type FloatingChatSourcesProviderProps,
  type FloatingChatState,
  isFloatingChatSide,
  useFloatingChat,
  useFloatingChatOptional,
} from "./floating-chat-context";
export {
  NewChatIcon,
  PeekCornerIcon,
  PeekFullIcon,
  PeekSideIcon,
} from "./floating-icons";
export type { FloatingChatTriggerAppearance } from "./floating-launcher-appearance";
export {
  createFloatingUrlPersistence,
  type FloatingChatStatePersistence,
  type FloatingChatStateSnapshot,
  type FloatingUrlPersistence,
  type FloatingUrlPersistenceOptions,
} from "./floating-persistence";
export {
  FloatingChatSidePanel,
  FloatingChatSidePanelProvider,
} from "./floating-side-panel";
export { FloatingChatTitleMenu } from "./floating-title-menu";
export {
  type MagnusHostCapabilities,
  MagnusHostProvider,
  type MagnusHostProviderProps,
  type MagnusHostSidePanel,
  type MagnusImageProps,
  type MagnusLinkProps,
  type MagnusMedia,
  type MagnusNavigation,
  type MagnusPersistence,
  useMagnusHost,
  useMagnusMedia,
  useMagnusNavigation,
  useMagnusPersistence,
} from "./host";
export {
  MagnusFloatingChat,
  type MagnusFloatingChatMode,
  type MagnusFloatingChatProps,
  MagnusSidebarChat,
} from "./magnus-floating-chat";
export { MagnusLogo, type MagnusLogoProps } from "./magnus-logo";
